import CreditMemoService from "../../../Services/CreditMemo/CreditMemoService";

export default class CreditMemoInvoiceViewDescription {
    static invoiceService = CreditMemoService.GetInvoiceById;
    static title = "Credit Memo Invoice Preview";
    static fileNamePrefix = "credit_memo_invoice";
    static attachInvoiceServiceFunction = CreditMemoService.AttachReportAsync;
}